import type { EventBusKey } from '@vueuse/core'

export const EventKey = {
  surveyUpdated: Symbol('surveyUpdated') as EventBusKey<{ surveyId: string }>,
  taskUpdated: Symbol('taskUpdated') as EventBusKey<{ surveyId: string }>,
  openFeedbackUpdated: Symbol('openFeedbackUpdated') as EventBusKey<{ surveyId: string }>,
  feedbackUpdated: Symbol('feedbackUpdated') as EventBusKey<{ feedbackId: string }>,
  teachingUnitUpdated: Symbol('teachingUnitUpdated') as EventBusKey<{ teachingUnitId: string }>,
  teamCreated: Symbol('teamCreated') as EventBusKey<{ teamId: string }>,
  teamUpdated: Symbol('teamUpdated') as EventBusKey<{ teamId: string }>,
  teachingUnitDeleted: Symbol('teachingUnitDeleted') as EventBusKey<{ teachingUnitId: string }>,
  teamTaskCreated: Symbol('teamTaskCreated') as EventBusKey<{
    teamId: string
    feedbackTopicId: string
  }>,
  organizationMemberCreated: Symbol('organizationMemberCreated') as EventBusKey<{
    memberId: string
  }>,
  organizationMemberUpdated: Symbol('organizationMemberUpdated') as EventBusKey<{
    memberId: string
  }>,
  updatedMemberPermissions: Symbol('updatedMemberPermissions') as EventBusKey<{
    memberId: string
  }>,
  organizationMemberDeleted: Symbol('organizationMemberDeleted') as EventBusKey<{
    memberId: string
  }>,
  dialogUpdated: Symbol('dialogUpdated') as EventBusKey<{
    dialogId: string
  }>,
  dialogSlideUpdated: Symbol('dialogSlideUpdated') as EventBusKey<{
    dialogId: string
    slideId: string
  }>,
  coacheeInvited: Symbol('coacheeInvited') as EventBusKey<{ coacheeId: string }>,
  coachingDeleted: Symbol('coachingDeleted') as EventBusKey<{ coacheeId: string }>,
  coachingAdded: Symbol('coachingAdded') as EventBusKey<{ coacheeId: string }>,
  coachingsAdded: Symbol('coachingsAdded') as EventBusKey<{ coacheeIds: string[] }>,
  coachingInvitationUpdated: Symbol('coachingInvitationUpdated') as EventBusKey<{
    coacheeId: string
  }>,
  feedbackTopicTaskUpdated: Symbol('feedbackTopicTaskUpdated') as EventBusKey<{
    feedbackTopicTaskId: string
  }>,
  coachFeedbackGoalsUpdated: Symbol('coachFeedbackGoalsUpdated') as EventBusKey<void>,
  objectiveUpdated: Symbol('objectiveUpdated') as EventBusKey<void>,
  assessmentCreated: Symbol('assessmentCreated') as EventBusKey<{ assessmentId: string }>,
  // teamDeleted: Symbol('team-deleted') as EventBusKey<{ teamId: string }>,
}
